import { useEffect, useState } from 'react';

import { datadogRum } from 'root/datadog/datadogRum';

export function useSale(transactionId: string) {
  const [sale, setSale] = useState<Sale>();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    try {
      fetch(
        `/API/V3/Account/${window.merchantos.account.id}/Sale/${transactionId}.json?load_relations=all`
      ).then((res) => {
        res.json().then(({ Sale }) => {
          setSale(Sale);
          setLoading(false);
        });
      });
    } catch (e) {
      datadogRum.addError(e, {
        accountId: window.merchantos.account.id,
        transactionId,
      });
    }
  }, [transactionId]);
  return { sale, loading };
}
